module.exports = {
    GET_USER_TRANSACTIONS_REQUEST: "app/GET_USER_TRANSACTIONS_REQUEST",
    UPDATE_USER_TRANSACTIONS_REQUEST: "app/UPDATE_USER_TRANSACTIONS_REQUEST",
}